export default __webpack_public_path__ + "static/media/photo--sm--kara.2ad1f1d7.jpg";